import API from '../helper/API';

export const getAllOrganization = async () => await API.get(`/organizations`);
